import { Grid } from "@material-ui/core";
import * as _ from "lodash";
import * as React from "react";

import {
  CustomerGroupFilterState,
  TernaryFilterOption,
} from "../../types/index";
import { FilterGroup } from "./constants";
import FilterContainer from "./FilterContainer";
import GenericTernaryButtonGroupFilter from "./GenericTernaryButtonGroupFilter";

interface Props {
  customerContactChannelsFilter: Pick<
    CustomerGroupFilterState,
    "optIn" | "phone" | "email"
  >;
  enabled: boolean;
  changeCustomerGroupFilter: (
    payload: Partial<CustomerGroupFilterState>
  ) => void;
  handleEnabledChange: (filterGroup: FilterGroup, checked: boolean) => void;
}

class CustomerContactChannelsFilter extends React.Component<Props> {
  public render(): JSX.Element {
    return (
      <FilterContainer
        enabled={this.props.enabled}
        title="Kontaktkanäle"
        onEnabledChange={(enabled) => {
          this.props.handleEnabledChange(
            FilterGroup.customerContactChannels,
            enabled
          );
        }}
      >
        {(disabled?: boolean) => (
          <Grid container={true} spacing={2}>
            <Grid item lg={6} md={12}>
              <Grid container>
                <Grid item={true} xs={12}>
                  <GenericTernaryButtonGroupFilter
                    title="Opt-In Telefon"
                    filterState={
                      this.props.customerContactChannelsFilter.optIn.phone
                    }
                    disabled={disabled}
                    onChange={(newFilterState: TernaryFilterOption) =>
                      this.handleChangeOptIn("phone", newFilterState)
                    }
                  />
                </Grid>
                <Grid item={true} xs={12}>
                  <GenericTernaryButtonGroupFilter
                    title="Opt-In Brief"
                    filterState={
                      this.props.customerContactChannelsFilter.optIn.mail
                    }
                    disabled={disabled}
                    onChange={(newFilterState: TernaryFilterOption) =>
                      this.handleChangeOptIn("mail", newFilterState)
                    }
                  />
                </Grid>
                <Grid item={true} xs={12}>
                  <GenericTernaryButtonGroupFilter
                    title="Opt-In E-Mail"
                    filterState={
                      this.props.customerContactChannelsFilter.optIn.email
                    }
                    disabled={disabled}
                    onChange={(newFilterState: TernaryFilterOption) =>
                      this.handleChangeOptIn("email", newFilterState)
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={6} md={12}>
              <Grid container>
                <Grid item={true} xs={12}>
                  <GenericTernaryButtonGroupFilter
                    title="E-Mail vorhanden"
                    filterState={this.props.customerContactChannelsFilter.email}
                    disabled={disabled}
                    onChange={(newFilterState: TernaryFilterOption) =>
                      this.handleChangeEMail(newFilterState)
                    }
                  />
                </Grid>
                <Grid item={true} xs={12}>
                  <GenericTernaryButtonGroupFilter
                    title="Telefonnummer vorhanden"
                    filterState={this.props.customerContactChannelsFilter.phone}
                    disabled={disabled}
                    onChange={(newFilterState: TernaryFilterOption) =>
                      this.handleChangePhone(newFilterState)
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </FilterContainer>
    );
  }
  private handleChangeOptIn = (
    optIn: string,
    newFilterState: TernaryFilterOption
  ) => {
    this.props.changeCustomerGroupFilter({
      optIn: {
        ...this.props.customerContactChannelsFilter.optIn,
        [optIn]: newFilterState,
      },
    });
  };

  private handleChangePhone = (newFilterState: TernaryFilterOption) => {
    this.props.changeCustomerGroupFilter({ phone: newFilterState });
  };

  private handleChangeEMail = (newFilterState: TernaryFilterOption) => {
    this.props.changeCustomerGroupFilter({ email: newFilterState });
  };
}

export default CustomerContactChannelsFilter;



// WEBPACK FOOTER //
// ./src/components/Filters/CustomerContactChannelsFilter.tsx